// ============================================================================
// YearPicker (GC-B, F-657) — selecteur d'annee deep-linkable `?year=YYYY`
// ============================================================================
// Portage du PoC components/salary/year-picker.tsx : `router.replace` (Next) ->
// `setSearchParams({ replace: true })` (react-router) — meme effet, l'annee ne
// pollue pas l'historique. Preserve les AUTRES params (dont `tab`, symetrie avec
// les tabHref qui preservent `year` — URL-reflected, P-CE5). `years` est attendu
// deja trie (desc) et inclut l'annee courante (resolue serveur). Une valeur non
// entiere n'est jamais emise. Select natif style GS_COMPONENTS.input (motif gest,
// pas de Select shadcn) — dark-aware, touch-manipulation.

import { useSearchParams } from 'react-router-dom';
import { GS_COMPONENTS } from '@gs/ui';
import { useTranslation } from '../../i18n';

export interface YearPickerProps {
  /** Annees selectionnables (desc, ∪ annee courante) — resolues serveur. */
  years: number[];
  /** Annee RETENUE par le serveur (jamais le param brut de l'URL). */
  value: number;
}

export function YearPicker({ years, value }: YearPickerProps) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  function onChange(next: string) {
    const year = Number(next);
    if (!Number.isInteger(year)) return;
    const params = new URLSearchParams(searchParams);
    params.set('year', String(year));
    setSearchParams(params, { replace: true });
  }

  return (
    <label className="flex w-fit items-center gap-2 text-field">
      <span className="text-slate-500 dark:text-slate-400">{t('gest:grilleCe.yearLabel')}</span>
      <select
        value={String(value)}
        onChange={(e) => onChange(e.currentTarget.value)}
        aria-label={t('gest:grilleCe.yearLabel')}
        className={`${GS_COMPONENTS.input} h-8 w-28 touch-manipulation py-0`}
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </label>
  );
}
